import {
  Breakpoints,
  styled,
  TextCustom,
} from '@vw-marketing/us-components';

import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledVehicleInteractiveCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.background.primary};
  margin-left: -8.33vw;
  margin-right: -8.33vw;
  
  @media (min-width: ${Breakpoints.b560}px) {
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.border.divider};
  }
  
  @media (min-width: ${Breakpoints.b1600}px) {
    min-width: 231px;
  }
`;

export const StyledVehicleInteractiveCardHeader = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: center;
      align-self: stretch;
      border-bottom: 1px solid ${theme.colors.border.divider};
      display: flex;
      gap: ${theme.size.static250};
      justify-content: center;
      padding: ${theme.size.static250} ${theme.size.grid002};

      .mobile-edit-button-container {
        display: block;
        height: 16px;
      }

      .mobile-edit-button-anchor {
        cursor: pointer;
      }
      
      .desktop-edit-button-container {
          display: none;
      }

      @media (min-width: 380px) {
        .mobile-edit-button-container {
          display: none;
        }

        .desktop-edit-button-container {
          display: block;
        }

        .mobile-edit-button-anchor {
          cursor: default;
        }
      }
      
      @media (min-width: ${Breakpoints.b560}px) {
        border-radius: 0;
        padding: ${theme.size.static250} ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b560}px) and (max-width: 959px) {
        .mobile-edit-button-container {
          display: block;
        }

        .mobile-edit-button-anchor {
          cursor: pointer;
        }

        .desktop-edit-button-container {
          display: none;
        }
      }

      @media (min-width: ${Breakpoints.b960}px) and (max-width: 1205px) {
        .mobile-edit-button-container {
          display: block;
        }
          
        .mobile-edit-button-anchor {
          cursor: pointer;
        }

        .desktop-edit-button-container {
          display: none;
        }
      }

      @media (min-width: ${Breakpoints.b1280}px) and (max-width: 1645px) {
        .mobile-edit-button-container {
          display: block;
        }

        .mobile-edit-button-anchor {
          cursor: pointer;
        }

        .desktop-edit-button-container {
          display: none;
        }
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.static300} ${theme.size.static350};
      }
    `;
  }}
`;

export const StyledVehicleInteractionCardModelHeaderButton = styled.div`
  button {
    height: 16px;
    width: 16px;

    :hover svg path {
      fill: ${({ theme }) => theme.colors.content.hover};
    }

    @media (min-width: 370px) {
      height: auto;
      width: auto;
    }
        
    @media (min-width: ${Breakpoints.b560}px) and (max-width: 959px) {
      height: 16px;
      width: 16px;
    }
          
    @media (min-width: ${Breakpoints.b960}px) and (max-width: 1181px) {
      height: 16px;
      width: 16px;
    }
            
    @media (min-width: ${Breakpoints.b1280}px) and (max-width: 1606px) {
      height: 16px;
      width: 16px;
    }
  }
`;

export const StyledAccordionContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      padding: ${theme.size.static250} ${theme.size.grid002};
      border-bottom: 1px solid ${theme.colors.border.divider};
      width: ${theme.size.grid024};

      @media (min-width: ${Breakpoints.b560}px) {
        padding: ${theme.size.static250} ${theme.size.static400};
        width: 100%;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.static300} ${theme.size.static350};
        width: 100%;
      }

      #Vehicle_Identifiers_Accordion {
        border-bottom: none;

        #Vehicle_Identifiers_Accordion_head {
          padding-top: 0px;
          padding-bottom: 0px;
          color: ${theme.colors.content.primary};
        }

        #Vehicle_Identifiers_Accordion_body {
          padding-bottom: 0px;
          padding-top: ${theme.size.dynamic0100};
        }
      }
    `;
  }}
`;

export const StyledAccordionInformationsCopyToClipboardContainer = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }: { theme: VWTheme }) => theme.size.static150};
  cursor: pointer;
  color: ${({ theme }: { theme: VWTheme }) => theme.colors.content.tertiary};

  :hover {
    color: ${({ theme }) => theme.colors.content.hover};
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.colors.content.hover};
  }
`;

export const StyledUserVehicleInformationContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
      width: 100%;
    `;
  }}
`;

export const StyledInformationContainer: any = styled.div`
  display: flex;
  justify-content: space-between;
  gap: auto;
  width: 100%;
`;

export const StyledVehicleInteractiveCardHeaderTitleSubtitle = styled.div`
  display: flex;
  min-width: 0px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  p {
    display: flex;
    align-items: center;
    margin: 0px;
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static150};

    @media (max-width: 370px) {
      :hover {
        color: ${({ theme }) => theme.colors.content.hover};
      }

      :hover svg path {
        fill: ${({ theme }) => theme.colors.content.hover};
      }
    }

    @media (min-width: ${Breakpoints.b560}px) and (max-width: 959px) {
      :hover {
        color: ${({ theme }) => theme.colors.content.hover};
      }

      :hover svg path {
        fill: ${({ theme }) => theme.colors.content.hover};
      }
    }

    @media (min-width: ${Breakpoints.b960}px) and (max-width: 1181px) {
      :hover {
        color: ${({ theme }) => theme.colors.content.hover};
      }

      :hover svg path {
        fill: ${({ theme }) => theme.colors.content.hover};
      }
    }

    @media (min-width: ${Breakpoints.b1280}px) and (max-width: 1606px) {
      :hover {
        color: ${({ theme }) => theme.colors.content.hover};
      }

      :hover svg path {
        fill: ${({ theme }) => theme.colors.content.hover};
      }
    }
  }

  ${({ theme }) => {
    return `
      gap: ${theme.size.static100};
      @media (min-width: ${Breakpoints.b1600})
        min-width: 183px;
    `;
  }}
`;

export const StyledVehicleInteractiveCardSpecialButton = styled.a`
${({ theme }) => {
    return `
    align-items: flex-start;
    align-self: stretch;
    border-bottom: 1px solid ${theme.colors.border.divider};
    color: ${theme.colors.content.primary};
    display: flex;
    flex-direction: column;
    gap: ${theme.size.dynamic0100};
    padding: ${theme.size.static250} ${theme.size.grid002};
    text-decoration: none;
    cursor: pointer;
    
    @media (min-width: ${Breakpoints.b560}px) {
      border-bottom: 0px;
      padding: ${theme.size.static250} ${theme.size.static400};
    }

    @media (min-width: ${Breakpoints.b560}px) {
      border-bottom: 0px;
      padding: ${theme.size.static250} ${theme.size.static400};
    }
    
    @media (min-width: ${Breakpoints.b1600}px) {
      padding: ${theme.size.static300} ${theme.size.static350};
    }
  `;
  }}

  :hover {
    color: ${({ theme }) => theme.colors.wishlist.icon.on.default};
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.colors.wishlist.background.hover};
  }
`;

export const StyledVehicleInteractiveCardSpecialButtonLabelControl = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  ${({ theme }) => {
    return `
      gap: ${theme.size.static250};
    `;
  }}
`;

export const StyledVehicleInteractiveCardSpecialButtonLabel = styled(TextCustom)`
  flex: 1 0 0;
`;
